<template>
  <div>
    <div v-if="tabForUser.every(item => !item.isShow)">
      Bạn không có quyền truy cập tab nào của Care. Vui lòng liên hệ admin!!!
    </div>
    <div v-else id="student-care-page">
      <div class="top-bar">
        <div class="group-action-button">
          <v-menu offset-y v-if="actionList.length > 0">
            <template #activator="{ on: onMenu }">
              <v-tooltip bottom>
                <template #activator="{ on: onTooltip }">
                  <v-btn
                    min-width="45"
                    style="margin-right: 10px;"
                    class="mb-2"
                    color="info"
                    small
                    v-on="{ ...onMenu, ...onTooltip }"
                  >
                    <v-icon>mdi-gesture-tap</v-icon>
                  </v-btn>
                </template>

                <span>Thao tác</span>
              </v-tooltip>
            </template>
            <v-list>
              <v-list-item
                v-for="(action, index) in actionList"
                :key="`${action.id}_${index}`"
                @click="showModalAction(action.type)"
              >
                <v-list-item-title>
                  {{ action.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
<!--            <v-list v-if="filterForm.typeCustomerCare === TYPE_CALL_STATUS.GIA_HAN || filterForm.typeCustomerCare === TYPE_CALL_STATUS.CHUYEN_SALES">-->
<!--              <v-list-item-->
<!--                v-for="(action, index) in actionExtend"-->
<!--                :key="`${action.id}_${index}`"-->
<!--                @click="showModalAction(action.type)"-->
<!--              >-->
<!--                <v-list-item-title>-->
<!--                  {{ action.title }}-->
<!--                </v-list-item-title>-->
<!--              </v-list-item>-->
<!--            </v-list>-->
          </v-menu>
          <v-menu
            :internal-activator="true"
            v-model="filterForm.openRowMenu"
            content-class="menu__customer--filter no-contain overflow-visible"
            :close-on-content-click="false"
            offset-y
          >
            <template #activator="{ on: onMenuCol }">
              <v-tooltip bottom>
                <template #activator="{ on: onTooltipCol }">
                  <v-btn
                    v-if="false"
                    min-width="45"
                    small
                    class="mb-2"
                    dark
                    v-on="{ ...onMenuCol, ...onTooltipCol }"
                  >
                    <v-icon>mdi-view-column</v-icon>
                  </v-btn>
                </template>

                <span>Cột hiển thị</span>
              </v-tooltip>
            </template>
            <CardTableShowField
              :filterForm="filterForm"
            />
          </v-menu>
        </div>
        <div class="tab-container">
          <v-tabs v-model="tab">
            <template v-for="tabb in tabForUser">
              <v-tab :key="tabb.code" @click="toggleTab(tabb.code)" v-show="tabb.isShow">{{ tabb.name }}</v-tab>
            </template>
  <!--          <v-tab @click="toggleTab('all')">Tất cả</v-tab>-->
  <!--          <v-tab v-show="!isStaffCareSaleExtend" @click="toggleTab('c0')">{{$store.state.typeCurriculum === 'online' ? 'TA0':'C0'}}</v-tab>-->
  <!--          <v-tab v-show="!isStaffCareSaleExtend" @click="toggleTab('care')">Chăm sóc định kỳ</v-tab>-->
  <!--          <v-tab v-show="!isStaffCareSaleExtend" @click="toggleTab('extension')">Gia hạn</v-tab>-->
  <!--          <v-tab @click="toggleTab('sales')">Chuyển sales</v-tab>-->
          </v-tabs>
        </div>
        <div class="search-form">
          <v-text-field
            class="search-text-field"
            placeholder="Tìm kiếm theo SDT, mã KH"
            height="25px"
            clearable
            @click:clear="clearSearchField"
            v-model.trim="filterForm.phoneNumber"
            @keyup.enter="searchRecords"
          ></v-text-field>
          <div class="group-btn-search" @click="searchRecords">
            Tìm kiếm
            <v-menu
              :internal-activator="true"
              v-model="filter.closeMenu"
              content-class="menu__customer no-contain overflow-visible"
              :close-on-content-click="false"
              :close-on-click="isCloseOnClick"
              style="z-index: 10"
            >
              <template v-slot:activator="menuON">
                <v-tooltip bottom style="z-index: 10;">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      medium
                      color="white"
                      v-on="on"
                      class="search-contact--dropdown"
                    >
                      <v-icon size="20"
                              v-on="menuON.on"
                      >mdi-chevron-down
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Tìm kiếm nâng cao</span>
                </v-tooltip>
              </template>
              <card-filter-form
                :filter="filter"
                :filterForm.sync="filterForm"
                :currentTab.sync="tab"
                @change-close-on-click="changeCloseOnClick"
              />
            </v-menu>
          </div>
        </div>
        <div class="d-flex" v-if="true">
          <v-select
            v-model="filterForm.limit"
            :items="limitOptions"
            style="width: 60px"
            @change="searchRecords"
            hide-details
            class="pt-0 mr-4"
          >
          </v-select>
          <div class="text-right mb-1 mt-2">
            <template v-if="totalItem">
              {{ showContactsIndex }}
            </template>
            <v-btn
              small
              class="pagination-btn-left"
              :disabled="filterForm.page == 1"
              @click="previousPage"
            >
              <v-icon>mdi-menu-left</v-icon>
            </v-btn>
            <v-btn
              small
              class="pagination-btn-right"
              :disabled="filterForm.page >= getTotalItem(totalItem, filterForm.limit)"
              @click="nextpage"
            >
              <v-icon>mdi-menu-right</v-icon>
            </v-btn>
          </div>
          <div style="width: 35px" v-if="totalItem">
            <v-text-field
              v-model="filterForm.pendingPage"
              :max="getTotalItem(totalItem, filterForm.limit)"
              class="pt-0"
              min="1"
              step="1"
              type="number"
              hide-details
              @input="applyPendingPage(getTotalItem(totalItem, filterForm.limit))"
            >
            </v-text-field>
          </div>
        </div>
      </div>
      <router-view :filterForm.sync="filterForm"
                  :studentForm.sync="studentForm"
                   v-slot="{ Component, route }"
      >
        <transition name="fade">
          <component :is="Component" :key="route.path" />
        </transition>
      </router-view>
      <ModalAddHeadTeacher v-if="isShowModalAddHeadTeacher" :studentForm.sync="studentForm"
                          :isShow="isShowModalAddHeadTeacher" :filterForm.sync="filterForm"
                          @close-modal-add-head-teacher="closeModalAddHeadTeacher()"/>
      <ModalChangeSale  v-if="isShowModalChangeSale" :studentForm.sync="studentForm"
                        :isShow="isShowModalChangeSale" :filterForm.sync="filterForm"
                        @close-modal-add-head-teacher="closeModalChangeSale()"/>
    </div>
  </div>
</template>

<script>
import checkPermission from '@/modules/student_care/mixins/checkPermission';
import moment from 'moment';
import TokenService from '@/helpers/token';
import { mapActions, mapGetters, mapState } from 'vuex';
import { SCHOOL_LEVEL, TYPE_CALL_STATUS, TYPE_CURRICULUM_OBJ } from '@/helpers/constant';
import CardFilterForm from './components/CardFilterForm.vue';
import CardTableShowField from './components/CardTableShowField.vue';
import ModalAddHeadTeacher from './components/ModalAddHeadTeacher.vue';
import ModalChangeSale from './components/ModalChangeSale.vue';
import {
  ieltsyTabPermissions,
  objPermissionsRoute,
  objPermissionsToTab,
  tabAndRelatedInfo,
  TUTOR_ACTION_PERMISSION,
  TUTOR_SECONDARY_ACTION_PERMISSION,
  TUTOR_TAB_INDEX,
  tutorTabPermissions,
  secondaryTabPermissions,
} from './constant/constant';

export default {
  name: 'StudentCare',
  components: {
    CardFilterForm,
    CardTableShowField,
    ModalAddHeadTeacher,
    ModalChangeSale,
  },
  mixins: [checkPermission],
  data() {
    return {
      isCloseOnClick: true,
      limitOptions: [10, 20, 50, 100, 200, 500],
      changeTabLoader: null,
      filter: {
        closeMenu: false,
      },
      currentTab: 'PeriodicallyCare',
      tab: 1,
      filterForm: {
        openRowMenu: false,
        status: '',
        searchInfo: '',
        courseEndDate: [],
        extend_at: [],
        subjectId: null,
        phoneNumber: '',
        page: 1,
        limit: 20,
        callTypes: [],
        callStatuses: [],
        headTeacher: [],
        subject_ids: [],
        openQuickView: true,
        typeCustomerCare: 1,
        historyCallId: 0,
        historyCallStatusId: [],
        checkboxAll: false,
        pendingPage: 1,
        sales: [],
        compareTypeNumberOfLessons: 'eq',
        compareTypeLatestCareDate: 'between',
        numberOfLessons: null,
        noEndDate: false,
        hasNoTeacher: false,
        hasNoSale: false,
        class_start_time: [],
        previous_end_date: [],
        class_code: '',
        program_ids: [],
        type_curriculum: _.cloneDeep(this.$store.state.typeCurriculum),
        hasNoSchool: false,
        school_id: [],
        programFilter: [],
        lastestCareDate: null,
        isSpecialCare: false,
        sortUpdatedAt: 'desc',
        courseId: null,
        study_time: [],
        compareHomeWorkType: null,
        undoneHomework: null,
      },
      taskFilerForm: {
        page: 1,
        pendingPage: 1,
        phoneNumber: '',
        ids: [],
        appointmentSchedule: [],
        type: [],
        curriculumId: [],
        status: [],
        limit: 20,
        callStatuses: [],
        typeScreen: 'tutor',
        sortAppointmentSchedule: 'desc',
      },
      studentForm: {
        selected: [],
      },
      filterFormOriginal: {},
      isShowModalAddHeadTeacher: false,
      isShowModalChangeSale: false,
      TYPE_CALL_STATUS,
      routeUser: {
        online: [],
        ieltsy: [],
      },
      tabForUser: [
        {
          code: 'all',
          name: 'Tất cả',
          isShow: false,
        },
        {
          code: 'c0',
          name: 'C0',
          isShow: false,
        },
        {
          code: 'tutor-task',
          name: 'Công việc',
          isShow: false,
        },
        {
          code: 'care',
          name: 'Chăm sóc định kỳ',
          isShow: false,
        },
        {
          code: 'special-care',
          name: 'Chăm sóc đặc biệt',
          isShow: true,
        },
        {
          code: 'extension',
          name: 'Gia hạn',
          isShow: false,
        },
        {
          code: 'sales',
          name: 'Chuyển sale',
          isShow: false,
        },
      ],
    };
  },
  created() {
    Bus.$on('reloadListTask', () => {
      Bus.$emit('recountTotalSuccess');
      this.getListTask(this.filterForm);
    });
    Bus.$on('sort-updated-at', async () => {
      if (this.filterForm.sortUpdatedAt === 'desc') {
        this.filterForm.sortUpdatedAt = 'asc';
      } else if (this.filterForm.sortUpdatedAt === 'asc') {
        this.filterForm.sortUpdatedAt = 'desc';
      }
      const loading = this.$loading.show();
      await this.getDataPeriodicallyCareTable(this.filterForm);
      loading.hide();
    });
    Bus.$on('filter-special-care-tutor', (item) => {
      this.toggleTab('special-care', item.contact_code);
    });
  },
  methods: {
    ...mapActions('student_care', ['getCourseExtensionShowField', 'getListGVCN', 'getListGVCNV2', 'getDataPeriodicallyCareTable', 'getListCallStatusCount', 'getListCallType', 'getListSale', 'apiUpdate', 'getListTotalGVCN', 'apiUpdateCSDK', 'getListProgram', 'getListTotalStation', 'apiUpdateGiaHan', 'getListSaleForRole']),
    ...mapActions('contact_status', ['getListStatus']),
    ...mapActions('blended', ['getListTask']),
    async toggleTab(tab, contactCode = null) {
      this.changeTabLoader = this.$loading.show();
      const searchText = this.filterForm.phoneNumber;
      if (tab === 'tutor-task' && this.tab !== TUTOR_TAB_INDEX.TutorTask) {
        this.filterForm = _.cloneDeep(this.taskFilerForm);
        this.filterForm.typeCustomerCare = TYPE_CALL_STATUS.CONG_VIEC;
        this.filterForm.phoneNumber = searchText;
        await this.setQueryByName('TutorTask');
        await this.fetchData();
      }
      if (tab === 'care' && this.filterForm.typeCustomerCare !== TYPE_CALL_STATUS.CHAM_SOC_DINH_KY) {
        this.filterForm = _.cloneDeep(this.filterFormOriginal);
        this.filterForm.typeCustomerCare = TYPE_CALL_STATUS.CHAM_SOC_DINH_KY;
        this.filterForm.phoneNumber = searchText;
        await this.setQueryByName('PeriodicallyCare');
        await this.fetchData();
      } else if (tab === 'extension' && this.filterForm.typeCustomerCare !== TYPE_CALL_STATUS.GIA_HAN) {
        this.filterForm = _.cloneDeep(this.filterFormOriginal);
        this.filterForm.phoneNumber = searchText;
        this.filterForm.typeCustomerCare = TYPE_CALL_STATUS.GIA_HAN;
        await this.setQueryByName('CourseExtension');
        await this.fetchData();
      } else if (tab === 'sales' && this.filterForm.typeCustomerCare !== TYPE_CALL_STATUS.CHUYEN_SALES) {
        this.filterForm = _.cloneDeep(this.filterFormOriginal);
        this.filterForm.phoneNumber = searchText;
        this.filterForm.typeCustomerCare = TYPE_CALL_STATUS.CHUYEN_SALES;
        await this.setQueryByName('TransferSales');
        await this.fetchData();
      } else if (tab === 'c0' && this.filterForm.typeCustomerCare !== TYPE_CALL_STATUS.C0) {
        this.filterForm = _.cloneDeep(this.filterFormOriginal);
        this.filterForm.phoneNumber = searchText;
        this.filterForm.typeCustomerCare = TYPE_CALL_STATUS.C0;
        await this.setQueryByName('C0');
        await this.fetchData();
      } else if (tab === 'all' && this.tab !== TUTOR_TAB_INDEX.ALL) {
        this.filterForm = _.cloneDeep(this.filterFormOriginal);
        this.filterForm.phoneNumber = searchText;
        this.filterForm.typeCustomerCare = undefined;
        await this.setQueryByName('All');
        await this.fetchData();
      } else if (tab === 'special-care' && this.tab !== TUTOR_TAB_INDEX.SpecialCare) {
        this.tab = TUTOR_TAB_INDEX.SpecialCare;
        this.filterForm = _.cloneDeep(this.filterFormOriginal);
        this.filterForm.phoneNumber = searchText;
        this.filterForm.typeCustomerCare = undefined;
        if (contactCode) {
          await this.setQueryByName('SpecialCare', contactCode);
        } else {
          await this.setQueryByName('SpecialCare');
        }
        await this.fetchData();
      }
      this.changeTabLoader.hide();
    },
    async setQueryByName(name, contactCode) {
      const replaceQuery = {
        name,
        query: {
          typeCurriculum: this.$store?.state?.typeCurriculum,
          contactCode,
        },
      };
      if (this.$store?.state?.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
        replaceQuery.query.tutorSchoolLevel = this.$route.query.tutorSchoolLevel ? this.$route.query.tutorSchoolLevel : SCHOOL_LEVEL.PRIMARY;
      }
      await this.$router.replace(replaceQuery);
    },
    changeCloseOnClick(val) {
      this.isCloseOnClick = val;
    },
    async fetchData() {
      if (this.$route.query.contactCode) {
        this.filterForm.phoneNumber = this.$route.query.contactCode;
      }
      this.filterForm.type_curriculum = this.$route.query.typeCurriculum;
      if (this.tab === TUTOR_TAB_INDEX.SpecialCare) {
        this.filterForm.isSpecialCare = true;
        this.filterForm.isSpecial = true;
      } else {
        this.filterForm.isSpecialCare = false;
        this.filterForm.isSpecial = false;
      }
      let paramCallType = {};
      if (this.filterForm.typeCustomerCare === 1 && this.filterForm.type_curriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
        paramCallType = {
          'filters[$in__typeCustomerCare]': '[1, 4]',
          'filters[$eq__type_curriculum]': this.filterForm.type_curriculum,
        };
      } else {
        paramCallType = {
          'filters[$eq__typeCustomerCare]': this.filterForm.typeCustomerCare,
          'filters[$eq__type_curriculum]': this.filterForm.type_curriculum,
        };
      }
      if (this.tab !== TUTOR_TAB_INDEX.TutorTask) {
        await Promise.allSettled([
          this.getDataPeriodicallyCareTable(this.filterForm),
          this.getListCallStatusCount(this.filterForm),
          this.getListStatus({
            typeCustomerCare: this.filterForm.typeCustomerCare,
            type_curriculum: _.cloneDeep(this.$store.state.typeCurriculum),
          }),
          this.getListCallType(paramCallType),
          // this.getListGVCN(),
          this.getListGVCNV2(),
          this.getListSaleForRole(),
          this.getListTotalGVCN(),
          this.getListProgram(),
          this.getListTotalStation(),
        ]);
      } else {
        if (this.$route.query.ids) {
          this.filterForm.ids = this.$route.query.ids.split(',');
        }
        await this.getListGVCNV2();
        await this.getListProgram();
        await this.getListTask(this.filterForm);
        Bus.$emit('recountTotalSuccess');
      }
    },
    getSale() {
      if (this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
        this.getListSaleForRole();
      } else {
        this.getListSale();
      }
    },
    closeModalAddHeadTeacher() {
      this.isShowModalAddHeadTeacher = !this.isShowModalAddHeadTeacher;
    },
    closeModalChangeSale() {
      this.isShowModalChangeSale = !this.isShowModalChangeSale;
    },
    // eslint-disable-next-line consistent-return
    showModalAction(modalType) {
      if (this.dataPeriodicallyCareTable && this.dataPeriodicallyCareTable.data && this.dataPeriodicallyCareTable.data.length > 0) {
        for (let i = 0; i < this.dataPeriodicallyCareTable.data.length; i += 1) {
          if (this.dataPeriodicallyCareTable.data[i] && this.dataPeriodicallyCareTable.data[i].checkbox) {
            if (modalType === 'add_head_teacher') {
              this.isShowModalAddHeadTeacher = true;
              return;
            }
            if (modalType === 'change_sale') {
              this.isShowModalChangeSale = true;
              return;
            }
            if (modalType === 'move_to_early_extension') {
              this.$swal({
                title: 'Bạn có chắc chắn muốn chuyển gia hạn sớm',
                confirmButtonText: 'Chuyển gia hạn sớm',
                showCancelButton: true,
                cancelButtonText: 'Quay lại',
              }).then((res) => {
                if (res.value) {
                  this.moveToEarlyExtension();
                }
              });
              return;
            }
            if (modalType === 'transition_to_routine_care') {
              this.$swal({
                title: 'Bạn có chắc chắn muốn chuyển sang chăm sóc định kỳ',
                confirmButtonText: 'Đồng ý',
                showCancelButton: true,
                cancelButtonText: 'Quay lại',
              }).then((res) => {
                if (res.value) {
                  this.moveToRoutineCare();
                }
              });
              return;
            }
          }
        }
      }
      this.$swal({
        title: 'Lỗi !',
        text: 'Vui lòng chọn khách hàng !!!',
      });
    },
    async moveToEarlyExtension() {
      let ghCallId = 0;
      let ghMoiCallStatusId = 0;
      if (this.allListStatus && this.allListStatus.length > 0) {
        for (let i = 0; i < this.allListStatus.length; i += 1) {
          if (this.allListStatus[i] && this.allListStatus[i].name === this.checkTypeGH() && this.allListStatus[i].data && this.allListStatus[i].data.length > 0) {
            for (let j = 0; j < this.allListStatus[i].data.length; j += 1) {
              if (this.allListStatus[i].data[j] && this.allListStatus[i].data[j].code === 'MOI') {
                ghCallId = this.allListStatus[i].id;
                ghMoiCallStatusId = this.allListStatus[i].data[j].id;
                break;
              }
            }
          }
          if (ghCallId && ghMoiCallStatusId) {
            break;
          }
        }
      }
      const listSelectedId = [];
      const oldData = [];
      // let isInappropriateContat = false;
      this.dataPeriodicallyCareTable.data.forEach(
        (contact) => {
          if (contact.checkbox) {
            // if (contact.type_customer_care !== TYPE_CALL_STATUS.CHAM_SOC_DINH_KY) {
            //   isInappropriateContat = true;
            // }
            listSelectedId.push(contact.id);
            oldData.push({ id: contact.id, call_id: contact.call_id });
          }
        },
      );
      // if (isInappropriateContat) {
      //   return this.$swal({
      //     type: 'error',
      //     title: 'Lỗi !',
      //     text: 'Học viên đã chọn không phù hợp !!!',
      //   });
      // }
      if (listSelectedId.length === 0) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Vui lòng chọn khách hàng !!!',
        });
      }

      let result = null;
      if (this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
        const params = {
          ids: listSelectedId,
        };
        result = await this.apiUpdateGiaHan(params);
      }
      if (this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) {
        const params = {
          obj: 'routine',
          data: {
            call_id: ghCallId,
            call_status_id: ghMoiCallStatusId,
            extend_at: moment(Date.now()).format('YYYY-MM-DD HH:mm:ss'),
            type_customer_care: 2,
          },
          filters: {
            $in__id: listSelectedId,
          },
          oldData,
        };
        result = await this.apiUpdate(params);
      }
      if ((this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY && result) || (this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE && result?.message === 'Success')) {
        await this.getDataPeriodicallyCareTable(this.filterForm); this.filterForm.checkboxAll = false;
        return this.$swal({
          type: 'success',
          title: 'Thành công',
          text:
            'Chuyển thành công!!!',
          timer: 1500,
        });
      }
      return this.$swal({
        type: 'error',
        title: 'Lỗi !',
        text: this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY ? 'Có lỗi khi chuyển !!!' : result.message,
      });
    },
    checkTypeCs() {
      if (this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
        return 'TA - CS';
      }
      if (this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) {
        return 'CS';
      }
      return '';
    },
    checkTypeC0() {
      if (this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
        return 'TA0';
      }
      if (this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) {
        return 'C0';
      }
      return '';
    },
    checkTypeGH() {
      if (this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
        return 'TA - GH';
      }
      if (this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) {
        return 'GH';
      }
      return '';
    },
    async moveToRoutineCare() {
      const codeC0Name = _.find(this.allListStatus, ['name', this.checkTypeC0()]);
      const codeC0MOI = _.find(codeC0Name.data, ['code', 'MOI']);
      const codeGH = _.find(this.allListStatus, ['name', this.checkTypeGH()]);
      const codeCS = _.find(this.allListStatus, ['name', this.checkTypeCs()]);
      const listSelected = [];
      let isInappropriateContact = false;
      const listSelectedCheck = _.filter(this.dataPeriodicallyCareTable.data, (params) => params.checkbox);
      listSelectedCheck.forEach(
        (contact) => {
          if (contact.type_customer_care !== TYPE_CALL_STATUS.GIA_HAN && contact.type_customer_care !== TYPE_CALL_STATUS.CHUYEN_SALES) {
            isInappropriateContact = true;
          }
          const { routine_history_json: routineHistoryJson } = contact;

          const CsdkHistory = _.filter(routineHistoryJson, (params) => params.call_id && params.call_id !== codeGH.id && params.call_id !== codeCS.id);
          const lastCSDK = _.last(CsdkHistory);
          if (!lastCSDK) {
            // tim` C0
            const objectSend = {
              call_id: codeC0Name.id,
              call_status_id: codeC0MOI.id,
              id: contact.id,
              type_customer_care: 4,
            };
            listSelected.push(objectSend);
          }
          if (lastCSDK) {
            const findCSDK = _.findIndex(this.allListStatus, ['id', lastCSDK.call_id]);

            const finalCSDK = findCSDK === this.allListStatus.length - 1 ? this.allListStatus[findCSDK] : this.allListStatus[findCSDK + 1];
            const codeMOI = _.find(finalCSDK.data, ['code', 'MOI']);
            const objectSend = {
              call_id: finalCSDK.id,
              call_status_id: codeMOI.id,
              id: contact.id,
              type_customer_care: 1,
            };
            listSelected.push(objectSend);
          }
        },
      );
      if (isInappropriateContact) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Học viên đã chọn không phù hợp !!!',
        });
      }
      if (listSelectedCheck.length === 0) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Vui lòng chọn khách hàng !!!',
        });
      }
      const params = {
        obj: 'routine',
        data: listSelected,
      };
      const result = await this.apiUpdateCSDK(params);
      if (result) {
        await this.getDataPeriodicallyCareTable(this.filterForm); this.filterForm.checkboxAll = false;
        return this.$swal({
          type: 'success',
          title: 'Thành công',
          text:
            'Chuyển thành công!!!',
          timer: 1500,
        });
      }
      return this.$swal({
        type: 'error',
        title: 'Lỗi !',
        text:
          'Có lỗi khi chuyển !!!',
      });
    },
    async searchRecords() {
      const loading = this.$loading.show();
      this.filterForm.page = 1;
      this.filterForm.pendingPage = 1;
      if (this.tab === TUTOR_TAB_INDEX.TutorTask) {
        Bus.$emit('recountTotalSuccess');
        await this.getListTask(this.filterForm);
      } else {
        await this.getDataPeriodicallyCareTable(this.filterForm);
        await this.getListCallStatusCount(this.filterForm);
      }
      loading.hide();
    },
    clearSearchField() {
      this.filterForm.phoneNumber = '';
      this.searchRecords();
    },
    async nextpage() {
      const loading = this.$loading.show();
      this.filterForm.page += 1;
      if (this.tab === TUTOR_TAB_INDEX.TutorTask) {
        await this.getListTask(this.filterForm);
      } else {
        await this.getDataPeriodicallyCareTable(this.filterForm);
      }
      this.filterForm.pendingPage += 1;
      loading.hide();
    },
    async previousPage() {
      const loading = this.$loading.show();
      this.filterForm.page -= 1;
      if (this.tab === TUTOR_TAB_INDEX.TutorTask) {
        await this.getListTask(this.filterForm);
      } else {
        await this.getDataPeriodicallyCareTable(this.filterForm);
      }
      this.filterForm.pendingPage -= 1;
      loading.hide();
    },
    /* eslint-disable */
    applyPendingPage: _.debounce(function (maxPage) {
      if (this.filterForm.pendingPage < 1) {
        this.filterForm.pendingPage = this.filterForm.page;
        this.getDataPeriodicallyCareTable(this.filterForm);
        return;
      }
      if (this.filterForm.pendingPage > maxPage) {
        this.filterForm.pendingPage = maxPage;
        this.filterForm.page = parseInt(this.filterForm.pendingPage, 10);
        this.getDataPeriodicallyCareTable(this.filterForm);
        return;
      }
      this.filterForm.page = parseInt(this.filterForm.pendingPage, 10);
      this.getDataPeriodicallyCareTable(this.filterForm);
    }, 1000),
    /* eslint-disable */
    async handleRouterStudentCare() {
      const currentCare = this.$store?.state?.typeCurriculum;
      let routerDirect = null;
      if (this.routeUser[currentCare] && this.routeUser[currentCare].length) {
        routerDirect = this.routeUser[currentCare].find(route => route == this.$route?.name) ?? this.routeUser[currentCare][0];
      }
      if (routerDirect && this.$route.name !== routerDirect) {
        await this.$router.replace({ name: routerDirect, query: { typeCurriculum: this.$store?.state?.typeCurriculum, tutorSchoolLevel: this.$route.query.tutorSchoolLevel ? this.$route.query.tutorSchoolLevel : SCHOOL_LEVEL.PRIMARY } });
        this.filterForm = _.cloneDeep(this.filterFormOriginal);
        this.tab = tabAndRelatedInfo[routerDirect] ? tabAndRelatedInfo[routerDirect].tab : null;
        this.filterForm.typeCustomerCare = tabAndRelatedInfo[routerDirect] ? tabAndRelatedInfo[routerDirect].typeCustomerCare : undefined;
        // Fix permission
        // if (this.isStaffCareSaleExtend) {
        //   const user = TokenService.getUser();
        //   this.filterForm.sales = [user.id];
        //   this.filterFormOriginal.sales = [user.id];
        // }
      } else {
        console.log('Người dùng không có quyền xem tab nào!!!');
      }
    },
    getRoutesForUser() {
      let userPermission = this.$store.state.permissions;
      // userPermission.push('c0-tab-ieltsy_read');
      // userPermission.push('periodic-tab-ieltsy_read');
      // userPermission.push('all-tab_read');
      // userPermission.push('extends-tab_read');
      // userPermission.push('periodic-tab_read');
      const ieltsyTabs = _.intersection(userPermission, ieltsyTabPermissions);
      const tutorTabs = _.intersection(tutorTabPermissions, userPermission);
      const secondaryTabs = _.intersection(secondaryTabPermissions, userPermission);
      let ieltsy = [];
      let online = [];
      let secondary = [];
      tutorTabs.forEach(per => {
        if (objPermissionsRoute[per]) online.push(objPermissionsRoute[per]);
      });
      secondaryTabs.forEach(per => {
        if (objPermissionsRoute[per]) online.push(objPermissionsRoute[per]);
      });
      ieltsyTabs.forEach(per => {
        if (objPermissionsRoute[per]) ieltsy.push(objPermissionsRoute[per]);
      });
      return {
        ieltsy,
        online,
        secondary
      }
    },
    getTabForUser() {
      let userPermission = this.$store.state.permissions;
      // userPermission.push('c0-tab-ieltsy_read');
      // userPermission.push('periodic-tab-ieltsy_read');
      // userPermission.push('all-tab_read');
      // userPermission.push('extends-tab_read');
      // userPermission.push('periodic-tab_read');
      const ieltsyTabs = _.intersection(userPermission, ieltsyTabPermissions);
      const tutorTabs = _.intersection(userPermission, tutorTabPermissions);
      const secondaryTabs = _.intersection(userPermission, secondaryTabPermissions);
      this.tabForUser.forEach(tabC => {
        tabC.isShow = false;
      });
      if (this.$store?.state?.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) {
        this.tabForUser[1].name = 'C0';
        ieltsyTabs.forEach(per => {
          if (objPermissionsToTab[per]) {
            let tabIndex = this.tabForUser.findIndex(e => e.code === objPermissionsToTab[per].code);
            this.tabForUser[tabIndex].isShow = true;
          }
        })
      }
      if (this.$store?.state?.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
        this.tabForUser[1].name = 'TA0';
        if (this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.PRIMARY) {
          tutorTabs.forEach(per => {
            if (objPermissionsToTab[per]) {
              let tabIndex = this.tabForUser.findIndex(e => e.code === objPermissionsToTab[per].code);
              this.tabForUser[tabIndex].isShow = true;
            }
          })
        } else if (this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY) {
          secondaryTabs.forEach(per => {
            if (objPermissionsToTab[per]) {
              let tabIndex = this.tabForUser.findIndex(e => e.code === objPermissionsToTab[per].code);
              this.tabForUser[tabIndex].isShow = true;
            }
          })
        }
      }
    },
  },
  watch: {
    tab: {
      handler(val) {
        const searchText = this.filterForm.phoneNumber;
        this.filterFormOriginal.typeCustomerCare = this.filterForm.typeCustomerCare;
        if (val === TUTOR_TAB_INDEX.TutorTask) {
          this.filterForm = _.cloneDeep(this.taskFilerForm);
        } else {
          this.filterForm = _.cloneDeep(this.filterFormOriginal);
          if (val === TUTOR_TAB_INDEX.SpecialCare) {
            this.filterForm.isSpecialCare = true;
            this.filterForm.isSpecial = true;
          } else {
            this.filterForm.isSpecialCare = false;
            this.filterForm.isSpecial = false;
          }
        }
        this.filterForm.phoneNumber = searchText;

      },
    },
    '$route.name': {
      async handler() {
        this.filterForm.type_curriculum = this.$store?.state?.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE ? TYPE_CURRICULUM_OBJ.ONLINE : this.$store?.state?.typeCurriculum;
        this.handleActiveRoute('student-care');
        const loading = this.$loading.show();
        if (this.$route.name === 'StudentCare') {
          await this.getTabForUser();
          if ((this.$store?.state?.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE && this.routeUser.online.includes('SpecialCare'))
            || (this.$store?.state?.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY && this.routeUser.ieltsy.includes('PeriodicallyCare'))) {
            this.filterForm = _.cloneDeep(this.filterFormOriginal);
            this.filterForm.tutorSchoolLevel = this.$route.query.tutorSchoolLevel ? this.$route.query.tutorSchoolLevel : SCHOOL_LEVEL.PRIMARY;
            if (this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) {
              this.$router.replace({ name: 'PeriodicallyCare', query: { typeCurriculum: this.$store?.state?.typeCurriculum } });
              this.tab = TUTOR_TAB_INDEX.PeriodicallyCare;
              this.filterForm.typeCustomerCare = TYPE_CALL_STATUS.CHAM_SOC_DINH_KY;
            } else {
              this.$router.replace({ name: 'SpecialCare', query: { typeCurriculum: this.$store?.state?.typeCurriculum, tutorSchoolLevel: this.$route.query.tutorSchoolLevel ? this.$route.query.tutorSchoolLevel : SCHOOL_LEVEL.PRIMARY } });
              this.tab = TUTOR_TAB_INDEX.SpecialCare;
              this.filterForm.typeCustomerCare = undefined;
            }
          } else {
            await this.handleRouterStudentCare();
          }
          await Promise.all([
            this.getListStatus({
              type_curriculum: _.cloneDeep(this.$store.state.typeCurriculum),
            }),
            this.fetchData(),
          ]);
        }
        loading.hide();
      },
      deep: true,
    },
    '$route.query.tutorSchoolLevel': {
      handler() {
        this.filterFormOriginal.tutorSchoolLevel = this.$route.query.tutorSchoolLevel ? this.$route.query.tutorSchoolLevel : SCHOOL_LEVEL.PRIMARY;
        this.filterForm.tutorSchoolLevel = this.$route.query.tutorSchoolLevel ? this.$route.query.tutorSchoolLevel : SCHOOL_LEVEL.PRIMARY;
      },
      deep: true,
    }
  },
  computed: {
    ...mapState('student_care', ['courseExtensionShowField', 'dataPeriodicallyCareTable']),
    ...mapState('blended', ['tasks']),
    ...mapState('contact_status', ['listStatus', 'allListStatus']),
    ...mapGetters('user', ['isStaffCareSaleExtend']),
    actionList() {
      const actionList = [];
      let actionListTemp = [];
      if (this.$route.query.tutorSchoolLevel == SCHOOL_LEVEL.PRIMARY || !this.$route.query.tutorSchoolLevel) actionListTemp = TUTOR_ACTION_PERMISSION.find((e) => e.tabIndex === this.tab) ? TUTOR_ACTION_PERMISSION.find((e) => e.tabIndex === this.tab).actions : [];
      if (this.$route.query.tutorSchoolLevel == SCHOOL_LEVEL.SECONDARY) actionListTemp = TUTOR_SECONDARY_ACTION_PERMISSION.find((e) => e.tabIndex === this.tab) ? TUTOR_SECONDARY_ACTION_PERMISSION.find((e) => e.tabIndex === this.tab).actions : [];
      actionListTemp.forEach((e) => {
        if (this.checkPermission(e.permission)) {
          actionList.push({
            title: e.title,
            type: e.type,
            store: 'all',
          });
        }
      });
      return actionList;
    },
    actionExtend() {
      let actionExtend = [];
      if (!this.isStaffCareSaleExtend) {
        actionExtend.push({
          title: 'Chuyển Sale gia hạn',
          type: 'change_sale',
          store: 'all',
        });
      }
      actionExtend.push({
        title: 'Chuyển sang chăm sóc định kì',
        type: 'transition_to_routine_care',
        store: 'all',
      });
      if (this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE && (this.filterForm.typeCustomerCare === TYPE_CALL_STATUS.CHUYEN_SALES || this.filterForm.typeCustomerCare === TYPE_CALL_STATUS.GIA_HAN)) {
        actionExtend = actionExtend.filter((item) => item.type !== 'transition_to_routine_care');
      }
      actionExtend.push({
        title: 'Chuyển quản lý lớp',
        type: 'add_head_teacher',
        store: 'all',
      });
      return actionExtend;
    },
    actionAll() {
      const actionList = [];
      if (!this.isStaffCareSaleExtend) {
        actionList.push({
          title: 'Chuyển Sale gia hạn',
          type: 'change_sale',
          store: 'all',
        });
      }
      if (this.$route.query.typeCurriculum !== TYPE_CURRICULUM_OBJ.ONLINE) {
        actionList.push({
          title: 'Chuyển sang chăm sóc định kì',
          type: 'transition_to_routine_care',
          store: 'all',
        });
      }
      actionList.push({
        title: 'Chuyển quản lý lớp',
        type: 'add_head_teacher',
        store: 'all',
      });
      actionList.push({
        title: 'Chuyển gia hạn sớm',
        type: 'move_to_early_extension',
        store: 'all',
      });
      return actionList;
    },
    totalItem() {
      if (this.tab === TUTOR_TAB_INDEX.TutorTask) {
        return this.tasks.count
      } else {
        return this.dataPeriodicallyCareTable ? this.dataPeriodicallyCareTable.totalItem : 0;
      }
    },
    showContactsIndex() {
      const maxIndex = parseInt(this.filterForm.page, 10) * parseInt(this.filterForm.limit, 10);
      if (maxIndex >= this.totalItem) {
        return `${maxIndex - parseInt(this.filterForm.limit, 10) + 1} - ${parseInt(this.totalItem, 10)}`;
      }
      return `${maxIndex - parseInt(this.filterForm.limit, 10) + 1} - ${maxIndex}`;
    },
  },
  async mounted() {
    // this.handleActiveRoute('student-care');
    let direct = false;
    const user = TokenService.getUser();
    const loading = this.$loading.show();
    this.filterForm.tutorSchoolLevel = this.$route.query.tutorSchoolLevel ? this.$route.query.tutorSchoolLevel : SCHOOL_LEVEL.PRIMARY;
    this.taskFilerForm.tutorSchoolLevel = this.$route.query.tutorSchoolLevel ? this.$route.query.tutorSchoolLevel : SCHOOL_LEVEL.PRIMARY;
    this.filterFormOriginal = _.cloneDeep(this.filterForm);
    if (this.$store?.state?.typeCurriculum === TYPE_CURRICULUM_OBJ.DUO) {
      loading.hide();
      this.$router.push({
        name: 'DuoCareList',
        query: {
          typeCurriculum: TYPE_CURRICULUM_OBJ.DUO,
        },
      });
      return;
    }
    this.routeUser = this.getRoutesForUser();
    await this.getTabForUser();
    // if (this.$route.name === 'SpecialCare') {
    //   this.tab = 5;
    //   this.filterForm.typeCustomerCare = TYPE_CALL_STATUS.CHAM_SOC_DAC_BIET;
    // }
    if (this.$route.name === 'TutorTask') {
      this.tab = TUTOR_TAB_INDEX.TutorTask;
      this.filterForm.typeCustomerCare = TYPE_CALL_STATUS.CONG_VIEC;
    }
    else if (this.$route.name === 'CourseExtension') {
      this.tab = TUTOR_TAB_INDEX.CourseExtension;
      this.filterForm.typeCustomerCare = TYPE_CALL_STATUS.GIA_HAN;
    } else if (this.$route.name === 'TransferSales') {
      this.tab = TUTOR_TAB_INDEX.TransferSales;
      this.filterForm.typeCustomerCare = TYPE_CALL_STATUS.CHUYEN_SALES;
    } else if (this.$route.name === 'C0') {
      this.tab = TUTOR_TAB_INDEX.C0;
      this.filterForm.typeCustomerCare = TYPE_CALL_STATUS.C0;
    } else if (this.$route.name === 'All') {
      this.tab = TUTOR_TAB_INDEX.ALL;
      this.filterForm.typeCustomerCare = undefined;
    } else if (this.$route.name === 'SpecialCare') {
      this.tab = TUTOR_TAB_INDEX.SpecialCare;
      this.filterForm.typeCustomerCare = undefined;
    } else if (this.$route.name === 'PeriodicallyCare') {
      this.tab = TUTOR_TAB_INDEX.PeriodicallyCare;
      this.filterForm.typeCustomerCare = TYPE_CALL_STATUS.CHAM_SOC_DINH_KY;
    } else {
      if (this.$store?.state?.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY && this.routeUser.ieltsy.includes('PeriodicallyCare')) {
        direct = true;
        if (this.$route.name !== 'PeriodicallyCare') {
          await this.$router.replace({ name: 'PeriodicallyCare', query: { typeCurriculum: this.$store?.state?.typeCurriculum } });
        }
        this.tab = TUTOR_TAB_INDEX.PeriodicallyCare;
        this.filterForm.typeCustomerCare = TYPE_CALL_STATUS.CHAM_SOC_DINH_KY;
      } else if ((this.$store?.state?.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE && this.routeUser.online.includes('SpecialCare'))) {
        direct = true;
        if (this.$route.name === 'StudentCare') {
          await this.$router.replace({ name: 'SpecialCare', query: { typeCurriculum: this.$store?.state?.typeCurriculum, tutorSchoolLevel: this.$route.query.tutorSchoolLevel ? this.$route.query.tutorSchoolLevel : SCHOOL_LEVEL.PRIMARY } });
        }
        this.tab = TUTOR_TAB_INDEX.SpecialCare;
        this.filterForm.typeCustomerCare = undefined;
        // else if (this.$route.name !== 'SpecialCare' && this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
        //   await this.$router.replace({ name: 'SpecialCare', query: { typeCurriculum: this.$store?.state?.typeCurriculum, tutorSchoolLevel: this.$route.query.tutorSchoolLevel ? this.$route.query.tutorSchoolLevel : SCHOOL_LEVEL.PRIMARY } });
        //   this.tab = 3;
        //   this.filterForm.typeCustomerCare = undefined;
        // }
      } else if ((this.$store?.state?.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE && this.routeUser.online.includes('PeriodicallyCare'))) {
        if (this.$route.name !== 'PeriodicallyCare') {
          await this.$router.replace({ name: 'PeriodicallyCare', query: { typeCurriculum: this.$store?.state?.typeCurriculum, tutorSchoolLevel: this.$route.query.tutorSchoolLevel ? this.$route.query.tutorSchoolLevel : SCHOOL_LEVEL.PRIMARY } });
        }
        this.tab = TUTOR_TAB_INDEX.PeriodicallyCare;
        this.filterForm.typeCustomerCare = TYPE_CALL_STATUS.CHAM_SOC_DINH_KY;
      }
    }
    if (this.isStaffCareSaleExtend
      && ((this.$store?.state?.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE && this.routeUser.online.includes('TransferSales'))
      || (this.$store?.state?.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY && this.routeUser.ieltsy.includes('TransferSales'))
    )) {
      direct = true;
      if (this.$route.name !== 'TransferSales') {
        const queryCustome = {typeCurriculum: this.$store?.state?.typeCurriculum}
        if (this.$store?.state?.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
          queryCustome.tutorSchoolLevel = this.$route.query.tutorSchoolLevel ? this.$route.query.tutorSchoolLevel : SCHOOL_LEVEL.PRIMARY;
        }
        await this.$router.replace({ name: 'TransferSales', query: queryCustome });
      }
      this.tab = TUTOR_TAB_INDEX.TransferSales;
      this.filterForm.typeCustomerCare = TYPE_CALL_STATUS.CHUYEN_SALES;
      // this.filterForm.sales = [user.id];
      // this.filterForm.sales = [user.id];
      // this.filterFormOriginal.sales = [user.id];
    }
    if (!direct) {
      await this.handleRouterStudentCare();
    }
    // if (this.isStaffCareSaleExtend) {
    //   this.filterForm.sales = [user.id];
    //   this.filterFormOriginal.sales = [user.id];
    // }
    await this.fetchData();
    await this.getListStatus({
      type_curriculum: _.cloneDeep(this.$store.state.typeCurriculum),
    });
    loading.hide();
  },
  beforeDestroy() {
    if (this.changeTabLoader) {
      this.changeTabLoader.hide();
    }
    Bus.$off('reloadListTask');
    Bus.$off('sort-updated-at');
    Bus.$off('contact-list-filter');
    Bus.$off('filter-special-care-tutor');
  },
};
</script>
<style scoped lang="scss">
.top-bar {
  min-height: 46px;
  min-width: 900px;
  border-radius: 0px;
  background: #FFFFFF;
  padding: 0px 15px 0px 15px;
  display: flex;
  justify-content: space-between;
}

.second-bar {
  margin-top: 15px;
  min-height: 39px;
  min-width: 900px;
  border-radius: 0px;
  background: #FFFFFF;
  display: flex;
  justify-content: flex-start;
}

.quick-filter-action {
  min-height: 39px;
  border-radius: 0px;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  padding: 13px;
  margin-right: 1px;
  cursor: pointer;
}

.button-create {
  background-color: #e91e63 !important;
  border-color: #e91e63 !important;
}
.group-btn-search {
  height: 30px;
  min-width: 80px;
  background: #E91E63;
  border-radius: 3px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  padding: 9px;
  margin-left: 20px;
  cursor: pointer;
}

.search-form {
  min-width: 250px;
  height: 22px;
  display: flex;
  justify-content: flex-start;
  padding-top: 9px;
}

.group-action-button {
  padding-top: 9px;
}
.pagination-btn-left, .pagination-btn-right {
  max-width: 30px !important;
  min-width: 30px !important;
  background-color: #ffffff !important;
}
.pagination-btn-left i, .pagination-btn-right i {
  color: rgba(0,0,0,.54) !important
}
.pagination-btn-left {
  margin: 0px 5px 2px 10px !important;
}
.pagination-btn-right {
  margin: 0px 10px 2px 5px !important;
}
@media screen and (max-width: 1500px) {
  .tab-container {
    width: 600px;
  }
}
@media screen and (max-width: 1350px) {
  .tab-container {
    width: 530px;
  }
}
</style>
